export const getModalTheme = (selectedItem) => {
    if (!selectedItem) return { header: "#455E1D", pill: "#455E1D" };

    const tipo = (selectedItem.tipo || "").toUpperCase();
    if (tipo === "EVENTO") return { header: "#257491", pill: "#257491" };

    const raw = (
        selectedItem.data?.tipoCaceriaDescripcion ||
        selectedItem.data?.tipoCaceria ||
        ""
    ).toString().toLowerCase();

    if (raw.includes("ojeo")) return { header: "#88B23A", pill: "#88B23A" };
    if (raw.includes("monter")) return { header: "#8B4513", pill: "#8B4513" };
    if (raw.includes("caza en mano")) return { header: "#D7812B", pill: "#D7812B" };
    if (raw.includes("gancho")) return { header: "#357942", pill: "#357942" };
    if (raw.includes("rececho")) return { header: "#2C4527", pill: "#2C4527" };
    if (raw.includes("aguardo")) return { header: "#C19A6B", pill: "#C19A6B" };
    if (raw.includes("otro")) return { header: "#7C6F57", pill: "#7C6F57" };

    return { header: "#d9463e", pill: "#d9463e" };
};
